export default {
    xmppConnectionConflict: {
        type: 'special',
        title: 'xmppConnectionConflict',
    },
    retryPasswordTooManyTimes: {
        type: 'dialog',
        title: 'Attention',
        content: 'email_signin_page_pwd_retry_limit',
        action1Text: 'ok',
    },
    APIServerError: {
        type: 'dialog',
        title: 'Attention',
        content: 'server_error_msg_9001',
        action1Text: 'ok',
    },
    SignInFail: {
        type: 'dialog',
        title: 'Attention',
        content: '3001',
        action1Text: 'KNOWMORE',
        action2Text: 'SIGNINAGAIN',
    },
    NetworkErrorSignIn: {
        type: 'dialog',
        title: 'Attention',
        content: 'error_no_internet_unsignin',
        action1Text: 'OK',
    },
    NetworkError: {
        type: 'dialog',
        title: 'Attention',
        content: 'error_no_internet_camera',
        action1Text: 'OK',
    },
    unVerifiedError: {
        type: 'dialog',
        title: 'Attention',
        content: 'email_verify_page_unverified',
        action1Text: 'OK',
    },
    CannotAccessMicrophone: {
        type: 'dialog',
        title: 'CannotAccessMicrophone',
        content: 'cannotAccessMicrophoneDetail',
        action1Text: 'OK',
    },
    FailedSetUpCamera: {
        type: 'dialog',
        title: 'failedToSetUp',
        content: 'failedToSetUpDetail',
        action1Text: 'OK',
    },
    switchCamera: {
        type: 'toast',
        content: 'setUpSuccess',
    },
    switchMicrophone: {
        type: 'toast',
        content: 'setUpSuccess',
    },
    motionOn: {
        type: 'toast',
        content: 'md_is_on',
    },
    motionDetected: {
        type: 'toast',
        content: 'motion_detected',
    },
}
